module.exports = "../dist/img/3-03.5a7e.jpg";